import { HttpParams } from '@angular/common/http';
import { Page } from '../Models/page';
import { Product } from '../Models/product';
import { ProductFilter } from '../Models/filter';


export class ProductBase {

  protected cast(data): Product {

    let product = new Product();

    product.setData(data);

    return product;
  }

  protected createPage(data): Page<Product> {

    let products = new Page<Product>();

    for (let i= 0; i < data['results'].length; i++) {

      products.push(this.cast(data['results'][i]));
    }

    products._links = data['_links'];
    products.count = data['count'];
    products.pages = data['pages'];
    products.current = data['current'];

    return products;
  }

  protected getParamsFromFilter(filter: ProductFilter): HttpParams {

    var params = new HttpParams();

    if (filter) {
      var keys = filter.keys();

      for (var i= 0; i < keys.length; i++) {

        if (filter.hasval(keys[i])) {
          if (typeof filter[keys[i]] === 'string') {
            let kw = keys[i] === 'query' ? 'search' : keys[i];
            params = params.append(kw, filter[keys[i]]);
          } else if (typeof filter[keys[i]] === 'number') {
            params = params.append(keys[i], filter[keys[i]]);
          } else{
            for (var j= 0; j < filter[keys[i]].length; j++) {
              if (filter[keys[i]]) {
                params = params.append(keys[i], filter[keys[i]][j]);
              }
            }
          }
        }
      }
    }

    return params;
  }
}



// WEBPACK FOOTER //
// ./src/app/Services/product.base.ts